import Vue from 'vue'
import VueRouter from 'vue-router'
import BlogList from './pages/BlogList.vue'
import EditBlog from './pages/EditBlog.vue'
import BlogDetail from './pages/BlogDetail.vue'
import AdminLogin from './pages/AdminLogin.vue'

Vue.use(VueRouter)

const routes = [
  { path : '/', component: BlogList},
  { path : '/admin/editBlog', component: EditBlog},
  { path : '/blog/category', component: BlogList},
  { path : '/blog/*', component: BlogDetail},
  { path : '/admin/login', component: AdminLogin},
]

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
